import { Component, Input, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { AppointmentsService } from '../../../services/appointments/appointments.service'

@Component({
	selector: 'app-modal-list-of-auxiliary-doctors',
	templateUrl: './modal-list-of-auxiliary-doctors.component.html',
	styleUrls: ['./modal-list-of-auxiliary-doctors.component.scss'],
})
export class ModalListOfAuxiliaryDoctors implements OnInit {
	@Input() title?: string
	@Input() appointmentId: string = ''
	form: FormGroup

	doctors: any[] = []
    loading: boolean = false

	constructor(
		public activeModal: NgbActiveModal,
		private formBuilder: FormBuilder,
		private appointmentsService: AppointmentsService
	) {
		this.form = this.formBuilder.group({
			doctor: ['', [Validators.required]],
		})
	}

	ngOnInit(): void {
		const self = this
		this.appointmentsService.getListOfAuxiliaryDoctors({
			fnSuccess(data?: any) {
				self.doctors = data.items.map((doctor: any) => ({
					label: `${doctor.name} ${doctor.last_name} - ${
						doctor.specialty || '--'
					}`,
					value: doctor.id,
				}))
			},
			fnError() {},
			fnFinalized() {},
		})
	}

	close() {
		this.activeModal.close()
	}

	onSubmit(): void {
		const self = this

		if (this.form.valid) {
			const { doctor } = this.form.value
			const id = doctor || ''
			if (id) {
                self.loading = true
				this.appointmentsService.sendAuxiliaryDoctor(
					id,
					this.appointmentId,
					{
						fnSuccess() {
							self.close()
						},
						fnError() {},
						fnFinalized() {
                            self.loading = false
                        },
					}
				)
				console.log('Submitting!!', this.form.value)
			}
		}
	}
}
